import { render, staticRenderFns } from "./ScanCanvasNew.vue?vue&type=template&id=8e9977d4&scoped=true&"
import script from "./ScanCanvasNew.vue?vue&type=script&lang=js&"
export * from "./ScanCanvasNew.vue?vue&type=script&lang=js&"
import style0 from "./ScanCanvasNew.vue?vue&type=style&index=0&id=8e9977d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9977d4",
  null
  
)

export default component.exports